import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivate, Router } from '@angular/router';
import { CustomSnackBarComponent } from 'app/pages/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class FirstAccessGuard implements CanActivate {
  constructor(private router: Router, private snackBar: MatSnackBar, private dialog: MatDialog) {}

  canActivate(): boolean {
    const firstAccess = localStorage.getItem('isFirstAccess');
    const actor = localStorage.getItem('userType');

    if (firstAccess === 'true') {
      this.openSnackBar("Olá! Que bom ter você no Posso Agendar. Finalize o cadastro do seu perfil para liberar todas as funcionalidades e ter a melhor experiência.", 'warning');
      switch (actor) {
        case 'organization':
          this.router.navigate(['organization-new/meus-dados']);
          break;
        case 'secretary':
          this.router.navigate(['secretarias-new/meus-dados']);
          break;
        case 'practitioner':
          this.router.navigate(['medico/meus-dados']);
          break;
        default:
          this.router.navigate(['patient-new/meus-dados']);
          break;
      }
      return false;
    } else {
      return true;
    }
  }

  openSnackBar(message: string, status: 'success' | 'error' | 'warning') {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: status === 'success' ? 'snack-success' : status === 'error' ? 'snack-error' : 'snack-warning',
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }

  openCenterSnackBar(message: string, status: 'success' | 'error' | 'warning') {

    this.dialog.open(CustomSnackBarComponent, {
      width: '650px',
    });

  }
}
